import useAuth from "../../../auth/useAuth";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { getClosureDelivery, getClosurePickup } from "../../../config.js";

export const useRouteClosure = () => {

    const auth = useAuth();
    const token = auth.globals.token;

    const {
        showErrorRequest,
    } = Alerts();


    const obtainDetailClosureDelivery = async (date, user_driver, setErrorRequest) => {
        if (date && date !== "") {
            try {
                let res = await fetch(getClosureDelivery(date, user_driver), {
                    method: "GET",
                    headers: {
                        //"Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                        //"x-access-token": token,
                    },
                    // cors: 'no-cors'
                })
                let data = await res.json()
                //console.log('delivery',data)
                if (res.ok) {
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)

                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                if (setErrorRequest !== undefined) {
                    setErrorRequest(errorRequest)
                } else {
                    return undefined;
                }
            }
        }
    }

    const obtainDetailClosurePickup = async (date, user_driver, setErrorRequest) => {
        if (date && date !== "") {
            try {
                let res = await fetch(getClosurePickup(date, user_driver), {
                    method: "GET",
                    headers: {
                        //"Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                        //"x-access-token": token,
                    },
                    // cors: 'no-cors'
                })
                let data = await res.json()
                //console.log('pickup',data)
                if (res.ok) {
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                if (setErrorRequest !== undefined) {
                    setErrorRequest(errorRequest)
                } else {
                    return undefined;
                }
            }
        }
    }


    return {
        //properties


        //methods
        obtainDetailClosureDelivery,
        obtainDetailClosurePickup

    }
}